import { useQuery } from "@tanstack/react-query";
import React from "react";
import styled from "styled-components";
import { getColors } from "../../../services/filamentService.js";
import Table from "../../components/core-components/Table.tsx";
import Button from "../../components/core-components/Button.tsx";
import Modal from "../../components/core-components/Modal.tsx";

import { toast, ToastContainer } from "react-toastify";
import { getFilamentTypes } from "../../../services/productsService.js";
import AddTypeComponent from "../../components/core-components/AddTypeComponent.tsx";

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
`;
const Header = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  width: 100%;
  height: 100%;
  border-bottom: 1px solid rgba(0, 0, 0, 0.15);
  padding-bottom: 0.5rem;
`;
const PageTitle = styled.h2`
  color: var(--secondary-font-color);
  font-family: Georgia, serif;
  letter-spacing: 1px;
`;
const TableContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 1rem;
  width: 100%;
  height: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
  }
`;
interface Props {}

const notify = () =>
  toast.success("Tip adăugat cu succes !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });

const notifyError = () =>
  toast.error("Tipul nu s-a putut adăuga !", {
    position: "top-center",
    autoClose: 2000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: false,
    draggable: false,
    progress: undefined,
    theme: "light",
  });
const TypesPage: React.FC<Props> = ({}) => {
  const [isModalOpen, setModalOpen] = React.useState(false);
  const { data: types, refetch } = useQuery({
    queryKey: ["types"],
    queryFn: () => getFilamentTypes(),
  });
  const { data: colors } = useQuery({
    queryKey: ["colors"],
    queryFn: () => getColors(),
  });

  return (
    <Wrapper>
      <Header>
        <PageTitle>Tipuri filament și culori</PageTitle>
        <Button
          id="add-material"
          onClick={() => setModalOpen(true)}
          text={"Adaugă material"}
          backgroundColor={"white"}
          outline="var(--secondary-green)"
          color="var(--secondary-green)"
        />
      </Header>

      <TableContainer>
        <Table
          columns={[
            { title: "ID", key: "id" },
            { title: "Tip filament", key: "value" },
          ]}
          rows={types || []}
        />
        <Table
          columns={[
            { title: "Cod culoare", key: "value" },
            { title: "Nume", key: "label" },
            { title: "Culoare", key: "color" },
          ]}
          rows={
            (colors &&
              colors.map((color) => {
                return {
                  value: color.colorCode,
                  label: color.colorName,
                  color: (
                    <div
                      style={{
                        width: "20px",
                        height: "20px",
                        border: "1px solid #dcdbdb",
                        backgroundColor: color.colorCode,
                      }}
                    ></div>
                  ),
                };
              })) ||
            []
          }
        />
      </TableContainer>

      {isModalOpen && (
        <Modal
          name="add-type-modal"
          title={"Adaugă tip filament"}
          onClose={() => setModalOpen(false)}
          content={
            <AddTypeComponent
              types={types.map((type) => type.value)}
              closeAddMode={(result) => {
                setModalOpen(false);
                if (result === "success") {
                  notify();
                  refetch();
                } else if (result === "error") {
                  notifyError();
                }
              }}
            />
          }
        />
      )}
      <ToastContainer />
    </Wrapper>
  );
};
export default TypesPage;
